import React from 'react'
import ApprovalLeaveRequest from './ApprovalLeaveRequest'

const LeaveApproval = () => {
    return <ApprovalLeaveRequest />
}

export default LeaveApproval
